import useGetOrganization from "../../../../Vote/Utilities/hooks/useGetOrganization";
import _ from "lodash";
import {Grid} from "@mui/material";
import {Box} from "@mui/system";
import CompanyLogo from "../../../../Vote/Utilities/CompanyLogo";
import CompanyResources from "../../../../Vote/Sections/HeaderSection/CompanyResources/CompanyResources";

export default function MessageDetailsHeaderSection({organizationId}) {
    const {organization} = useGetOrganization(organizationId);
    const name = _.get(organization, 'name');
    const logo = _.get(organization, 'logo');

    return (
        <Grid container sx={{borderBottom: '1px solid #CED4D4'}}>
            <Grid item xs={12} sm={12} md={6} lg={6} sx={{padding: '20px'}}>
                <Box sx={{display: 'flex'}}>
                    <Box>
                        <CompanyLogo logoUrl={logo} />
                    </Box>
                </Box>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6} sx={{}}>
                <Grid item xs={12} sm={12} md={9} lg={9}>
                    <CompanyResources />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                    {/*TODO: Add a component here*/}
                </Grid>
            </Grid>
        </Grid>
    )
}